import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PosOrderApiService, PosOrderReceiptDto } from '../data-access/pos-order-api.service';
import { PosReportsApiService } from '../data-access/pos-reports-api.service';
import { PosInformeDashboard } from '../models/pos-informe.models';
import {
  PosCashOutListQuery,
  PosCashOutListResult,
  PosCashOutResume,
  PosCompleteCashOutResult,
  PosVoidCashOutResult,
} from '../models/pos-traslado.models';
import { PosTransaccionesDashboard, PosTxRow } from '../models/pos-transacciones.models';

@Injectable()
export class PosReportsService {
  private readonly api = inject(PosReportsApiService);
  private readonly ordersApi = inject(PosOrderApiService);

  ventasDashboard(
    locationId: string,
    options: {
      reportDate?: string;
      startDatetime?: string;
      endDatetime?: string;
    } = {}
  ): Observable<PosInformeDashboard> {
    return this.api.ventasDashboard(locationId, options);
  }

  transaccionesDashboard(
    locationId: string,
    options: {
      page?: number;
      per?: number;
      startDatetime?: string;
      endDatetime?: string;
      paymentMethods?: readonly string[];
      status?: string;
      q?: string;
    } = {}
  ): Observable<PosTransaccionesDashboard> {
    return this.api.transaccionesDashboard(locationId, options);
  }

  cancelOrder(id: string, note: string): Observable<{ errors: string[] }> {
    return this.api.cancelOrder(id, note);
  }

  getOrderForReceipt(id: string): Observable<PosOrderReceiptDto | null> {
    return this.ordersApi.getForReceipt(id);
  }

  /** Pedido único por id (deep-link `?orderId=` desde Finanzas u otros módulos). */
  getOrderTxRow(id: string): Observable<PosTxRow | null> {
    return this.ordersApi.getForTxRow(id);
  }

  listCashOuts(
    locationId: string,
    options: PosCashOutListQuery = {}
  ): Observable<PosCashOutListResult> {
    return this.api.listCashOuts(locationId, options);
  }

  cashOutResume(
    locationId: string,
    startDatetime: string,
    endDatetime: string,
    cashOutDate?: string
  ): Observable<PosCashOutResume> {
    return this.api.cashOutResume(locationId, startDatetime, endDatetime, cashOutDate);
  }

  completeCashOut(
    locationId: string,
    options: {
      startDatetime: string;
      endDatetime: string;
      cashOutDate?: string;
      confirmedEmployeeIds?: readonly string[];
    }
  ): Observable<PosCompleteCashOutResult> {
    return this.api.completeCashOut(locationId, options);
  }

  voidCashOut(id: string, reason: string, notes: string): Observable<PosVoidCashOutResult> {
    return this.api.voidCashOut(id, reason, notes);
  }
}
